import conversationList from './conversationList'
import messageList from './messageList'
import promptMessage from './promptMessage'
export default {
  namespaced: true,
  state: {
    TIM: null,
    imSign: '',
    trtcConfig: '',
    imReady: false,
    invitation: null,
    callStatus: 'idle', // calling:连接中 connected: 已连接
    to: '', // 聊天对象id
    isCompleted: false, // 调用过后台消息列表标识
    imMessage: null,
    reeditMessage: null, // 重新编辑
    revMessage: null,
    showGroupVideoLive: false,
    isRecording: false, // 录音停止当前在播放的语音
    avatarUrl: '', // 当前用户头像
    headPortrait: '' // 和自己聊天（对方）头像
  },
  mutations: {
    SET_GROUP_VIDEO_LIVE(state, value) {
      state.showGroupVideoLive = value
    },
    SET_AVATAR(state, url) {
      state.avatarUrl = url
    },
    SET_HEAD_PORTRATI(state, url) {
      state.headPortrait = url
    },
    SET_IS_RECORDING(state, value) {
      state.isRecording = value
    },
    SET_REEDIT(state, message) {
      state.reeditMessage = message
    },

    SET_SIGN(state, val) {
      state.imSign = val
    },
    SET_IM_READY(state, payload) {
      state.imReady = payload
    },
    SET_IM_REVOKED(state, msg) {
      state.revMessage = msg
    },
    SET_IM_MESSAGE(state, msg) {
      state.imMessage = msg
    },
    SET_IM_ISCOMPLETE(state, flag) {
      state.isCompleted = true
    },
    SET_IM_TO(state, id) {
      // 更新to的时候重置标识
      state.isCompleted = false
      state.to = id
      state.message.conversationId = `GROUP${id}`
    },
    SET_CALL_STATUS(state, val) {
      state.callStatus = val
    },
    SET_INVITATION(state, val) {
      state.invitation = val
    },
    SET_TRTC_CONFIG(state, val) {
      state.trtcConfig = val
    }
  },
  actions: {},
  getters: {},
  modules: {
    list: conversationList,
    message: messageList,
    promptMessage
  }
}
